"use client";

import { AudioWaveform, Headphones, SlidersHorizontal as Sliders, User, ArrowRight } from 'lucide-react';
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LaTransformaciNDelServicio() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.05
  });
  const capabilities = [{
    icon: User,
    number: "01",
    title: "HUESPED",
    description: "Consulta cuándo llegará su transporte.",
    span: "md:col-span-1"
  }, {
    icon: AudioWaveform,
    number: "02",
    title: "TIMEARRIVAL",
    description: "Procesa y actualiza información en tiempo real.",
    span: "md:col-span-1"
  }, {
    icon: Headphones,
    number: "03",
    title: "RESORT",
    description: "Coordina mejor sus operaciones",
    span: "md:col-span-1"
  }];
  return <section className="bg-background py-16 px-4 md:px-8 overflow-hidden">
      <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes marching-ants {
          0% { stroke-dashoffset: 20; }
          100% { stroke-dashoffset: 0; }
        }
        .animate-marching-ants {
          stroke-dasharray: 4, 4;
          animation: marching-ants 3s linear infinite;
        }
        .group-hover-fast .animate-marching-ants {
          animation-duration: 1s;
        }
      `
    }} />
      
      <div className="max-w-7xl mx-auto group/flow">
        <div ref={headerRef} className={`mb-12 transition-all duration-1000 ${headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <div className="flex items-center gap-4 mb-6">
            <div className="h-[1px] w-12 bg-primary" />
            <span className="font-mono text-sm tracking-widest uppercase text-muted-foreground">La Solución</span>
          </div>
          <h2 className="text-4xl md:text-6xl font-semibold tracking-tighter max-w-3xl leading-tight">
            Información en tiempo real para <span className="text-accent">huéspedes y operaciones</span>
          </h2>
        </div>

        {}
        <div className={`mb-8 transition-all duration-1000 delay-100 ${gridVisible ? 'opacity-100' : 'opacity-0'}`}>
          <svg className="w-full h-8 overflow-visible" viewBox="0 0 1200 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 16H1200" className="stroke-border animate-marching-ants transition-all duration-300 group-hover/flow:stroke-accent group-hover/flow:stroke-[2px]" strokeWidth="1" />
            {}
            <path d="M390 10L400 16L390 22" className="stroke-accent fill-none" strokeWidth="2" />
            <path d="M790 10L800 16L790 22" className="stroke-accent fill-none" strokeWidth="2" />
            <path d="M1190 10L1200 16L1190 22" className="stroke-accent fill-none" strokeWidth="2" />
          </svg>
        </div>

        <div ref={gridRef} className={`relative grid grid-cols-1 md:grid-cols-3 gap-4 transition-all duration-1000 delay-200 group-hover/flow:group-hover-fast ${gridVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-[1px] bg-border -translate-y-1/2 z-0" />

          {capabilities.map((item, i) => <div key={i} data-index={i} className="group relative z-10 bg-card border border-border p-8 flex flex-col justify-between transition-colors !w-auto !h-[220px] md:col-span-1 hover:bg-accent/5">
              <div className="flex justify-between items-start mb-8">
                <div className="p-3 bg-background border border-border group-hover:border-accent transition-colors">
                  <item.icon className="w-6 h-6 text-primary group-hover:text-accent transition-colors" />
                </div>
                <div className="flex items-center gap-2">
                  <span className="font-mono text-xs text-muted-foreground tracking-widest">{item.number}</span>
                  {i < capabilities.length - 1 && <ArrowRight className="w-3 h-3 text-muted-foreground group-hover:text-accent transition-colors" />}
                </div>
              </div>
              
              <div>
                <h3 className="text-xl font-semibold mb-3 tracking-tight group-hover:text-accent transition-colors">
                  {item.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed text-base max-w-md !w-[320px]">
                  {item.description}
                </p>
              </div>

              <div className="absolute bottom-0 left-0 h-1 w-0 bg-accent transition-all duration-500 group-hover:w-full" />
            </div>)}
        </div>
      </div>
    </section>;
}